// Sidebar map toggles (Key Villages eye, Notable-labels eye, GWS & VDP
// filter) reset to their defaults whenever the region or bereich focus
// changes — EXCEPT a toggle the user set from the FULL region view, which
// survives focusing a bereich or swapping bereiche within that region.
//
// origin: { region, full } recorded when the user flips the toggle
//         (full = no bereich was focused at the time), or null.
// prev/next: { region } navigation snapshots (region null on overview).
export function keepsToggle(origin, prev, next) {
  if (!origin) return false;
  if (next.region == null) return false;          // leaving to overview
  if (prev.region !== next.region) return false;  // region changed
  return origin.region === next.region && origin.full === true;
}
